module.exports = __webpack_public_path__ + "static/media/two.4ee88f45.png";